const validUrls = [
  'https://core-store-dev-au.apps.ad.corelogic.asia/',
  'https://corestore-uat.corelogic.com.au/',
  'https://www.corelogic.com.au/',
  'http://confluence.ad.corelogic.asia/',
  'https://www.cotality.com',
  'https://www.cotality.com/au'
]


const SAFE_PATH_PATTERN = /^\/[^<>"'`]*$/;

const clearQueryParams = () => {
  const { pathname } = window.location;
  if (SAFE_PATH_PATTERN.test(pathname)) {
    window.history.replaceState(null, null, pathname);
  }
};

const isValidUrl = (url) => {
  return validUrls.find(x => (url.startsWith(x))) ? true : false
}

export { clearQueryParams, isValidUrl };

